import Component from './group_setting.vue'
export default Component
